export const GLOBAL = { ROOT: '/' };
export const FORM = { ROOT: 'form' };
export default {
  FORM,
  GLOBAL,
};
